module.exports = __webpack_public_path__ + "static/media/support.1d4440e8.svg";